import moment from 'moment'

// Trim leading/trailing whitespace and collapse runs of spaces inside the string
// to a single space. Newlines are preserved so multi-line text keeps its line breaks.
function normalizeWhitespace (value) {
  return value.trim().replace(/ +/g, ' ')
}

export function trimStringsAndRemoveEmpty (obj) {
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'string') {
      const trimmed = normalizeWhitespace(obj[key])
      if (trimmed === '') {
        obj[key] = null
      } else {
        obj[key] = trimmed
      }
    } else if (Array.isArray(obj[key])) {
      obj[key] = obj[key].map(item => {
        if (typeof item === 'string') {
          return normalizeWhitespace(item)
        } else if (typeof item === 'object' && item !== null) {
          return trimStringsAndRemoveEmpty(item)
        }
        return item
      }).filter(item => item !== '') // Filter out empty strings
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      obj[key] = trimStringsAndRemoveEmpty(obj[key])
    }
  })
  return obj
}

export function formatDate (inputString) {
  if (inputString == null) {
    return null
  }
  return moment(inputString).format('MM/DD/YYYY')
}

export function formatDateTime (inputString) {
  if (inputString == null) {
    return null
  }
  return moment(inputString).format('MM/DD/YYYY h:mm A')
}

export function getShortText (text) {
  if (text == null) { return text }
  let results = ''
  const words = text.split(' ')
  while (results.length < 240 && words.length > 0) {
    results += words.splice(0, 1) + ' '
  }
  if (results.length < text.length) { results += ' ...' }
  return results
}

export function isNullOrWhitespace (value) {
  return !value || !value.trim()
}

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
  reader.readAsDataURL(file)
})

export function toTitleCase (str) {
  return str
    .split('_')
    .filter(x => x.length > 0)
    .map((x) => (x.charAt(0).toUpperCase() + x.slice(1)))
    .join(' ')
}
